import { createSlice } from "@reduxjs/toolkit";

const addModalQuestionCategorySlice = createSlice({
  name: "addModalQuestionCategory",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalQuestionCategorySlice.actions;
export default addModalQuestionCategorySlice.reducer;
